module.exports = __webpack_public_path__ + "img/Atyrau.e9d9b8c3.png";